import { useQuery } from 'react-query';

import { SimilarDealReport, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useRelatedDealsQuery(guid: Guid | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.Deal.Related(guid),
		() => AxiosUtils.getResponseData<SimilarDealReport>(api.get(CerebroApiEndpoints.Deals.Related(guid))),
		{ enabled: guid !== undefined }
	);
}
